import { StyleSheet } from 'react-native'
import Animated from 'react-native-reanimated'

import { useSheetFade } from '../hooks/useSheetFade'
import { Box, useTheme } from '../theme/restyle'

// The flow sheets' affordance. A drawer that opens over one of them draws a
// wider bar higher up, so the two read as different layers.
const DEFAULT_WIDTH = 36
const DEFAULT_TOP = 8

const AnimatedBox = Animated.createAnimatedComponent(Box)

export interface GrabberProps {
  /** Bar width; the drawer variant is wider than a flow sheet's. */
  width?: number
  /** Distance from the sheet's top edge. */
  top?: number
  /** Fade with the sheet's rise — see {@link useSheetFade}. */
  fadeWithSheet?: boolean
}

/**
 * The bottom-sheet drag affordance. Absolutely positioned so each top bar lays
 * out its own content independently. Sheets rendering this must pass
 * `handleComponent={null}` to gorhom, or its default handle draws a second
 * grabber above it.
 */
export function Grabber({
  width = DEFAULT_WIDTH,
  top = DEFAULT_TOP,
  fadeWithSheet = false,
}: GrabberProps) {
  const theme = useTheme()
  const fade = useSheetFade(fadeWithSheet)
  return (
    <AnimatedBox
      testID="grabber"
      alignItems="center"
      pointerEvents="none"
      style={[styles.overlay, { top }, fade]}
    >
      <Box
        style={[
          styles.bar,
          { width, backgroundColor: theme.border.elements.default.color },
        ]}
      />
    </AnimatedBox>
  )
}

const styles = StyleSheet.create({
  overlay: { position: 'absolute', left: 0, right: 0 },
  bar: { height: 5, borderRadius: 999 },
})
